import { useSelector } from 'react-redux'

import { makeSelectFeatureSwitches } from '@webapp/core/stores/global/selectors'
import { usePOBillToSettingsPresenter } from '@webapp/modules/purchasing/features/get-po-bill-to-settings/presenters/UsePOBillToSettingsPresenter'

/**
 * Orchestration hook for POBillToDefaultsView.
 *
 * Owns the CQS bridge between the Bill To preference query feature and its
 * command presenter, plus the `punchout` feature-switch read behind the
 * PunchOut note: PunchOut groups carry their own bill to location and bill to
 * contact, so these defaults never reach those POs. Tenants without PunchOut
 * are not shown the caveat.
 */
export const usePOBillToDefaultsView = () => {
  const {
    primaryCategory,
    contact,
    contactUser,
    isLoadingContactUser,
    isLoading,
    isError,
    isContactUserError,
  } = usePOBillToSettingsPresenter()

  const { punchout } = useSelector(makeSelectFeatureSwitches())

  return {
    states: {
      primaryCategory,
      contact,
      contactUser,
      isLoadingContactUser,
      isLoading,
      // Both errors leave the fields showing defaults, not saved values; keep
      // them inert so a debounced save cannot persist the defaults
      isDisabled: isError || isContactUserError,
      showPunchoutNote: Boolean(punchout),
    },
  }
}
